import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantTaskSharedService } from '../../services/wealthlane-award-services';

const useGetAuditTrails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      id: number;
      title: string | null | undefined;
      type: null;
      sub: null;
      message: string | null | undefined;
      date: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const auditTrails = useQuery(
    ['getAuditTrails'],
    async () => {
      return await handleRequest(
        ParticipantTaskSharedService.getApiAwardApiAppParticipantTaskAuditTrails()
      );
    },
    {
      select: (data) => {
        return data?.map((item, index: number) => {
          return {
            id: index,
            title: item.name,
            type: null,
            sub: null,
            message: item.message,
            date: item.auditDate,
          };
        });
      },
    }
  );
  return auditTrails;
};

export default useGetAuditTrails;
